import React from 'react';

const Card = ({ 
  children, 
  className = '', 
  padding = 'default',
  ...props 
}) => {
  const baseClasses = 'bg-neutral-50 hairline';
  
  const paddingClasses = {
    none: '',
    sm: 'p-4',
    default: 'p-6',
    lg: 'p-8'
  };

  const classes = `${baseClasses} ${paddingClasses[padding]} ${className}`;

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

export default Card; 